import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=de5aebda&scoped=true"
import script from "./zixun.vue?vue&type=script&lang=js"
export * from "./zixun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5aebda",
  null
  
)

export default component.exports